import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TitleChange } from '../services/title-change';

@Component({
  selector: 'app-everything',
  imports: [],
  templateUrl: './everything.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './everything.scss',
})
export class Everything {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Everything in one place`);
    this.dynamicTitle.description(`Everything from the site on one page ordered chronologically.`);
  }
}
